import React, { useState } from "react";
import "./App.css";
import Alert from "./components/Alert";
import Navbar from "./components/Navbar";
import TextForm from "./components/TextForm";
import About from "./components/About";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {
	const [mode, setMode] = useState("light");
	const handleToggle = (theme) => {
		setMode(theme);
		document.body.setAttribute("class", `bg-${theme}`);
		let a = document.querySelectorAll("nav a");
		theme === "light"
			? (document.body.style.color = "black")
			: (document.body.style.color = "white");
		a.forEach((element) => {
			theme !== "light"
				? (element.style.color = "white")
				: (element.style.color = "black");
		});

		// if (mode === 'light') {
		//   setMode('dark')
		//   document.body.style.backgroundColor = 'rgb(39 43 47)'
		//   document.body.style.color = 'white'
		//   // document.title = `TextUtils Dark`
		//   showAlert('success', `Dark mode has been enabled`)
		// } else {
		//   setMode('light')
		//   document.body.style.backgroundColor = 'white'
		//   document.body.style.color = 'black'
		//   // document.title = `TextUtils Light`
		//   showAlert('success', `Light mode has been enabled`)
		// }
	};

	const [alert, setAlert] = useState(null);
	const showAlert = (type, message) => {
		setAlert({
			type: type,
			msg: message,
		});
		setTimeout(() => {
			setAlert(null);
		}, 2000);
	};

	return (
		<>
			<Router>
				<Navbar title="TextUtils" mode={mode} handleToggle={handleToggle} />
				<div className="form-check form-switch switch-container">
					<Alert alert={alert} />
					{/* <div className="switch">
            <label
              className="form-check-label mx-2"
              htmlFor="flexSwitchCheckChecked"
            >{`${mode} mode`}</label>
            <input
              className="form-check-input"
              onClick={handleToggle}
              type="checkbox"
              role="switch"
              id="flexSwitchCheckChecked"
            />
          </div> */}
				</div>
				<Routes>
					{/* exact matches exact path */}
					<Route
						exact
						path="/"
						element={
							<TextForm
								heading="Enter Your Text Here To Convert"
								mode={mode}
								showAlert={showAlert}
								setAlert={setAlert}
							/>
						}
					/>
					<Route exact path="/about" element={<About mode={mode} />} />
				</Routes>
			</Router>
		</>
	);
}

export default App;
